import React from 'react';
import { PendingSwitch, renderRoutes } from 'libs/router-config';
import { routes } from 'routes';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'styles/index.scss';
const App = () => (React.createElement(PendingSwitch, { routes: routes }, renderRoutes(routes)));
export default App;
